/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import styles from './styles';
import BreadIcon from '../Offer/BreadIcon';

export interface Props {
  titlePart: React.ReactNode;
  logo: string | undefined;
  id: string;
}

const BreadTitle = (props: Props) => {
  const { titlePart, logo, id } = props;
  return (
    <div css={styles.paymentOptionBreadTitle}>
      <BreadIcon id={id} logo={logo} />
      <strong>{titlePart}</strong>
    </div>
  );
};

export default BreadTitle;
